import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, ServicioGasto, SearchServicioGastoRequest, SearchServicioGastoResponse, SaveServicioGastoDto, TipoGastoComunidadServicioGasto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class ServicioGastoService extends CrudService<ServicioGasto, number, SaveServicioGastoDto, SearchServicioGastoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'servicioGasto', sharedFunctions);

  }

  getTiposGastoServicios(id: number): Observable<GenericResponse<TipoGastoComunidadServicioGasto[]>> {
    return this._http.get<GenericResponse<TipoGastoComunidadServicioGasto[]>>(this._serviceUrl + '/' + id + '/tipos-gasto-servicio', this.httpOptions);
  }
}